import { PublicSurveyScreen } from '@/features/surveys';

export default PublicSurveyScreen;
